var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TabWrapper',{attrs:{"tabContent":_vm.tabContent,"activeTab":_vm.activeTab},on:{"changeTab":_vm.changeTab},scopedSlots:_vm._u([{key:"tabBody",fn:function(){return [_c(_vm.contentToShow,{tag:"component"})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }